// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AuthSetting--next-sr-only--2FBeji8","widthFull":"AuthSetting--widthFull--3eUT9cK","footerButtonsContainer":"AuthSetting--footerButtonsContainer--1hcTB_P"};